import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { Campaign } from "../../models/campaign.model";
import { PermissionCheck } from "../../shared/permission";
import { DialogUtils } from "../../helper/dialog.helper";
import { ScreenUtils } from "../../helper/screen.helper";
import { PublicApiDataProvider } from "../../data-provider/public-api.dp";
import { Utils } from "../../helper/utils.helper";
import { NavigationBarHelperService } from "../navigation/navigation-bar.helper";

let PublicApi = {
    selector: "vcPublicApi",
    templateUrl: "/angular/components/public-api/public-api.component.html",
    bindings: {},
    controller: class PublicApiController {
        public readonly itemType = "access token";
        public readonly headline = "A good start is half the battle";
        public readonly subheading =
            "You currently don't have any API keys generated! Click below to get started";
        public readonly buttonText = "Generate API Key";
        public readonly image = "no-results.svg";

        public campaign: Campaign;
        public accessTokens: any[];

        private readonly dialog: DialogUtils;
        private readonly $window: any;
        public readonly utils: Utils;
        public readonly screen: ScreenUtils;

        private dataProvider: PublicApiDataProvider;
        public permissionProvider: PermissionCheck;
        public navigationBarService: NavigationBarHelperService;

        constructor(
            DialogUtils: DialogUtils,
            Utils: Utils,
            $window: any,
            ScreenUtils: ScreenUtils,
            CampaignDataProvider: CampaignDataProvider,
            PermissionCheck: PermissionCheck,
            NavigationBarHelperService: NavigationBarHelperService,
            PublicApiDataProvider: PublicApiDataProvider
        ) {
            Utils.accessCheck();

            this.$window = $window;
            this.dialog = DialogUtils;
            this.utils = Utils;
            this.screen = ScreenUtils;
            this.navigationBarService = NavigationBarHelperService;
            this.dataProvider = PublicApiDataProvider;
            this.permissionProvider = PermissionCheck;

            this.campaign = CampaignDataProvider.activeCampaign;
            this.navigationBarService.setShowBackButton(true);

            this.dataProvider
                .allAccessTokens(false)
                .then((accessTokens: any[]) => {
                    this.accessTokens = accessTokens;
                });
        }

        requestAccess() {
            this.$window.Intercom(
                "showNewMessage",
                "Hi, I would like to use the Ecanvasser API"
            );
        }

        generateApiKey(ev: any): void {
            this.dataProvider.createAccessToken().then((accessToken: any) => {
                this.dataProvider
                    .allAccessTokens(true)
                    .then((accessTokens: any[]) => {
                        this.accessTokens = accessTokens;
                    });
                this.dialog.show({
                    component: "vc-access-token-dialog",
                    targetEvent: ev,
                    skipHide: true,
                    clickOutsideToClose: true,
                    ariaLabel: "Access Token",
                    locals: {
                        accessToken: accessToken.token,
                        title: "Access Token",
                    },
                });
            });
        }

        revokeApiKey(accessToken: any): void {
            this.dataProvider.revokeAccessToken(accessToken).then(() => {
                this.dataProvider
                    .allAccessTokens(true)
                    .then((accessTokens: any[]) => {
                        this.accessTokens = accessTokens;
                    });
            });
        }
    },
};
angular.module("publicApi").component(PublicApi.selector, PublicApi);
